import { PageHeading } from "../../components/common/pageHeading/PageHeading";

import bg from "../../assests/images/inventory_bg.avif";
import { CategoryData } from "../../components/category/categoryData/CategoryData";
import { NavLink } from "react-router-dom";
import { useIsSalesExecutive } from "../../customHooks/roleChecker/useIsSalesExecutive";
import { useIsSeniorSalesExecutive } from "../../customHooks/roleChecker/useIsSeniorSalesExecutive";
export const CategoryList = () => {
  const isSalesExecutive = useIsSalesExecutive();
  const isSeniorSalesExecutive = useIsSeniorSalesExecutive();
  return (
    <div className="mb-5">
      <PageHeading title={"Category List"} />
      <section className="container py-2">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 text-center">
            <h1 className="display-4">Supply Corner</h1>
            <p className="lead">Category information</p>
            {isSalesExecutive || isSeniorSalesExecutive ? (
              <NavLink
                to="/reporting"
                className="btn btn-outline-warning btn-lg"
              >
                Reporting
              </NavLink>
            ) : (
              <NavLink
                to="/dashboard"
                className="btn btn-outline-warning btn-lg"
              >
                Dashboard
              </NavLink>
            )}
          </div>
          <div className="col-md-6">
            <img src={bg} className="img-fluid rounded" alt="Business" />
          </div>
        </div>
      </section>
      <CategoryData />
    </div>
  );
};
